export const futureInternshipTranslations = {
  lv: {
    title: 'Tuvākās prakses',
    create: 'Izveidot vakanci',
    description: 'Kad izglītības iestāde izveido praksi, tā parādās šeit.',
    count: '{{count}} prakses',
    count_zero: '{{count}} prakšu',
    count_one: '{{count}} prakse',
    count_other: '{{count}} prakses',
    visible: 'Redzamas {{count}} tuvākās prakses',
    visible_zero: 'Redzamas {{count}} tuvāko prakšu',
    visible_one: 'Redzama {{count}} tuvākā prakse',
    visible_other: 'Redzamas {{count}} tuvākās prakses',
    free: 'Bezmaksas kontā redzamas pirmās 20 vēl nesākušās prakses. Meklēšana, filtri un kārtošana pieejama ar aktīvu abonementu.',
    search: 'Meklēt pēc prakses, programmas vai izglītības iestādes…',
    loadError: 'Neizdevās ielādēt tuvākās prakses',
    filterError: 'Neizdevās ielādēt kategorijas',
    empty: 'Nav atrasta neviena prakse',
    emptyBody: 'Mainiet meklēšanu vai filtrus. Jaunas izglītības iestāžu prakses parādīsies šeit.',
    activeFilters: 'Aktīvie filtri:',
    categoryFilter: 'Kategorijas: {{count}}',
    clearSearch: 'Notīrīt meklēšanu',
    clearCategories: 'Notīrīt kategorijas',
    columns: {
      prof: 'Profesija',
      eduOrg: 'Izglītības iestāde',
      program: 'Prakses programma',
      start: 'Sākums',
      end: 'Beigas',
      length: 'Ilgums',
      internCount: 'Praktikanti',
    },
    weeks: '{{count}} ned.',
    months: '{{count}} mēn.',
  },
  en: {
    title: 'Upcoming internships',
    create: 'Create vacancy',
    description: 'Internships appear here when educational institutions create them.',
    count: '{{count}} internships',
    count_one: '{{count}} internship',
    count_other: '{{count}} internships',
    visible: '{{count}} upcoming internships visible',
    visible_one: '{{count}} upcoming internship visible',
    visible_other: '{{count}} upcoming internships visible',
    free: 'Free accounts show the first 20 internships that have not started. Search, filters and sorting are available with an active subscription.',
    search: 'Search by internship, program or educational institution…',
    loadError: 'Could not load upcoming internships',
    filterError: 'Could not load categories',
    empty: 'No internships found',
    emptyBody:
      'Adjust your search or filters. New internships from educational institutions will appear here.',
    activeFilters: 'Active filters:',
    categoryFilter: 'Categories: {{count}}',
    clearSearch: 'Clear search',
    clearCategories: 'Clear categories',
    columns: {
      prof: 'Profession',
      eduOrg: 'Educational institution',
      program: 'Internship program',
      start: 'Start',
      end: 'End',
      length: 'Duration',
      internCount: 'Interns',
    },
    weeks: '{{count}} wk.',
    months: '{{count}} mo.',
  },
}
